import React from 'react';
import { useTranslation } from 'react-i18next';

export function PreviewBanner() {
  const { t } = useTranslation();

  return (
    <div className="bg-primary/10 border-b border-primary/20 py-2">
      <div className="container flex items-center justify-center text-sm">
        <span className="text-primary font-medium">
          {t('preview.message', 'This is a preview version')}
        </span>
      </div>
    </div>
  );
}